import { motion } from "framer-motion";

const layers = [
  { h: "Fábrica", t: "El corazón productivo que abastece a todo el sistema.", role: "Produce" },
  { h: "Franquicia", t: "El modelo replicable: de la pasta fría a lo caliente y la ensalada.", role: "Se replica" },
  { h: "Local", t: "La experiencia y la línea de eventos que solo vive donde naciste.", role: "No se toca" },
  { h: "Distribución", t: "La marca en góndola, más allá de tu radio.", role: "Crece" },
];

const MammaArquitectura = () => {
  return (
    <section
      id="arquitectura"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(217 61% 10%), hsl(220 69% 2%))",
      }}
    >
      <div className="container px-4 max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <span
            className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-5 block"
            style={{ color: "#7ab7fd" }}
          >
            El orden de fondo
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-[1.1] mb-6">
            Cuatro frentes,
            <br />
            <span style={{ color: "#7ab7fd" }}>una sola marca.</span>
          </h2>
          <p className="italic text-base md:text-lg text-white/60 leading-relaxed max-w-2xl mx-auto">
            Hoy Mamma Pasta le habla a públicos muy distintos con un solo nombre. La
            arquitectura define quién es quién, para que cada frente sume valor a la
            marca en lugar de diluirla.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {layers.map((l, i) => (
            <motion.div
              key={l.h}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="rounded-2xl border border-white/10 p-6 flex flex-col"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              <h3 className="font-display text-xl font-semibold text-white mb-3">
                {l.h}
              </h3>
              <p className="text-sm text-white/65 leading-relaxed flex-1 mb-5">
                {l.t}
              </p>
              <span
                className="text-[10px] uppercase tracking-[0.2em] font-semibold"
                style={{ color: "#7ab7fd" }}
              >
                {l.role}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MammaArquitectura;
